export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Cancelled.93be4e64.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};